import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useConvertingPageStore from 'utils/trackPage/store/useConvertingPageStore';

const safePath = (p?: string | null) => (p && p.trim().length ? p : '/');

type RequestIdleCb = (cb: () => void, opts?: { timeout?: number }) => number;
type CancelIdleCb = (handle: number) => void;

const scheduleIdle = (cb: () => void, timeout = 2000): (() => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const ric = (window as unknown as { requestIdleCallback?: RequestIdleCb }).requestIdleCallback;
  const cic = (window as unknown as { cancelIdleCallback?: CancelIdleCb }).cancelIdleCallback;

  if (ric && cic) {
    const handle = ric(cb, { timeout });

    return () => cic(handle);
  }

  const handle = window.setTimeout(cb, 0);

  return () => window.clearTimeout(handle);
};

export const TrackConvertingPage = () => {
  const router = useRouter();
  const setPreviousPath = useConvertingPageStore(state => state.setPreviousPath);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handleRouteChangeStart = () => {
      const from = safePath(window.location.pathname);
      sessionStorage.setItem('previousPath', from);
      setPreviousPath(from);
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    const cancelIdle = scheduleIdle(() => {
      const current = safePath(window.location.pathname);
      const initialPath = sessionStorage.getItem('initialPath');
      if (!initialPath) {
        sessionStorage.setItem('initialPath', current);
      }

      const storedPrev = sessionStorage.getItem('previousPath');
      setPreviousPath(safePath(storedPrev || initialPath || current));
    });

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      cancelIdle();
    };
  }, []);

  return null;
};
